import { Reveal } from "./Reveal";
import { scrollToId } from "./Navbar";

export default function Footer() {
  return (
    <footer data-testid="footer" className="pt-24 pb-24 md:pb-10 px-6 md:px-12 lg:px-24 overflow-hidden">
      <Reveal>
        <button
          data-testid="footer-quote-button"
          onClick={() => scrollToId("#quote")}
          className="group block text-left w-full"
        >
          <span className="block text-xs uppercase tracking-[0.3em] text-smoke mb-6">
            Ready when you are
          </span>
          <span className="font-serif font-light tracking-tighter leading-[0.9] text-[16vw] lg:text-[11vw] block select-none">
            <span className="text-outline transition-colors duration-500 group-hover:text-bone group-hover:[-webkit-text-stroke-width:0px]">
              AFTER
            </span>{" "}
            <span className="italic text-ember">PAINT</span>
          </span>
        </button>
      </Reveal>

      <div className="mt-20 pt-8 border-t border-line flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <p className="text-xs uppercase tracking-[0.2em] text-smoke">
          © 2026 After Paint
        </p>
        <p
          data-testid="footer-compliance"
          className="text-xs uppercase tracking-[0.2em] text-smoke"
        >
          Lic. 205444C · ABN 12 474 073 126
        </p>
        <div className="flex flex-wrap items-center gap-8">
          <a
            data-testid="footer-phone-link"
            href="tel:0410514499"
            className="text-xs uppercase tracking-[0.2em] text-smoke hover:text-ember transition-colors duration-300"
          >
            0410 514 499
          </a>
          <a
            data-testid="footer-email-link"
            href="mailto:afterpaint@hotmail.com"
            className="text-xs uppercase tracking-[0.2em] text-smoke hover:text-ember transition-colors duration-300"
          >
            afterpaint@hotmail.com
          </a>
        </div>
      </div>
    </footer>
  );
}
